import React from "react";

import { templates } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { TabFeatureAttributeBlock } from "../apps/configurator/containers/TabFeatureAttributeBlock";
import { getSpacingClasses } from "../blocks/spacing";

export const Template = (
    props: templates.TabFeatureAttributeBlockTemplate,
): React.JSX.Element | null => {
    const cmsData = JSON.parse(props.cms);
    if (!cmsData) {
        return null;
    }
    return (
        <div
            className={concatClassNames([
                "tab-feature-attribute-block",
                cmsData.spacing ? getSpacingClasses(cmsData.spacing) : "",
            ])}
        >
            <TabFeatureAttributeBlock {...cmsData} />
        </div>
    );
};
